import styled from 'styled-components';

export const NewsletterFormCentered = styled.form`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: ${({ theme }) => theme.spacing.m};
  input {
    width: 40%;
  }
  @media screen and (max-width: 600px) {
    flex-direction: column;
    align-items: stretch;
    gap: ${({ theme }) => theme.spacing.s};
    padding: ${({ theme }) => theme.spacing.s};
    input {
      width: 100%;
      min-width: 0;
    }
    button {
      width: 100%;
      min-width: 0;
    }
  }
`;
